import type { DatePickerChangeEvent } from "@progress/kendo-vue-dateinputs";

export const datePickerLoseFocus = function (e: DatePickerChangeEvent) {
  const event = e.event;
  const inputElement = e.component?.dateInputRef?.element();

  // #25339: Lose focus on date picker when date is selected from the calendar
  if (!inputElement || event?.target == inputElement) return;
  setTimeout(() => {
    inputElement.blur();
  }, 500);
};
